import { Routes } from '@angular/router';
import { AuthComponent } from './layout/auth/auth.component';
import { PortalComponent } from './layout/portal/portal.component';
import { DashboardComponent } from './modules/dashboard/dashboard.component';
import { AdminUsersComponent } from './modules/users/admin-users/admin-users.component';
import { ItagTipUsersComponent } from './modules/users/itag-tip-users/itag-tip-users.component';
import { UserProfileComponent } from './modules/users/user-profile/user-profile.component';
import { CategoriesConfComponent } from './modules/configurations/categories-conf/categories-conf.component';
import { RegionsConfComponent } from './modules/configurations/regions-conf/regions-conf.component';
import { AuthGuard } from '@shared/_services/auth.guard';
import { ViewUserLocationsComponent } from './modules/users/user-profile/view-user-locations/view-user-locations.component';
import { UserDetailsComponent } from './modules/users/user-profile/user-details/user-details.component';
import { UserDevicesComponent } from './modules/users/user-profile/user-devices/user-devices.component';
import { UserThemesComponent } from './modules/users/user-profile/user-themes/user-themes.component';
import { UserSubscriptionsComponent } from './modules/users/user-profile/user-subscriptions/user-subscriptions.component';
import { UserHistoryComponent } from './modules/users/user-profile/user-history/user-history.component';
import { UserLocationComponent } from './modules/users/user-location/user-location.component';

export const routes: Routes = [
    { path: '', redirectTo: 'login', pathMatch: 'full' },
    { path: "login", component: AuthComponent },
    { 
        path: "portal", 
        component: PortalComponent, 
        canActivate: [AuthGuard],
        children: [
            { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
            { path: "dashboard", component: DashboardComponent, canActivate: [AuthGuard]  },
            { path: "admin-users", component: AdminUsersComponent, canActivate: [AuthGuard] },
            { path: "users", component: ItagTipUsersComponent, canActivate: [AuthGuard] },
            { 
                path: "user",
                component: UserProfileComponent,
                children: [
                    { path: '', redirectTo: ':userId/profile', pathMatch: 'full' },
                    { path: ":userId/profile", component: UserDetailsComponent, canActivate: [AuthGuard] },
                    { path: ":userId/devices", component: UserDevicesComponent, canActivate: [AuthGuard] },
                    { path: ":userId/themes", component: UserThemesComponent, canActivate: [AuthGuard] },
                    { path: ":userId/subscriptions", component: UserSubscriptionsComponent, canActivate: [AuthGuard] },
                    { path: ":userId/history", component: UserHistoryComponent, canActivate: [AuthGuard] },
                    { path: ":userId/locations", component: ViewUserLocationsComponent, canActivate: [AuthGuard] },
                ], 
            },
            
            { path: "categories-conf", component: CategoriesConfComponent, canActivate: [AuthGuard] },
            { path: "regions-conf", component: RegionsConfComponent, canActivate: [AuthGuard] },
            { path: "locations", component: UserLocationComponent, canActivate: [AuthGuard] },

        ]
     },

    { path: "**", redirectTo: "login", pathMatch: "full" },
    {
        path: 'users/:userId/devices/:deviceId/locations', component: UserLocationComponent, canActivate: [AuthGuard]
      },
];
